import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { supabase } from "@/integrations/supabase/client";

export const Route = createFileRoute("/_authenticated")({
  ssr: false,
  beforeLoad: async () => {
    const { data, error } = await supabase.auth.getUser();
    if (error || !data.user) throw redirect({ to: "/admin/login" });

    // Only admin/staff may enter the admin subtree. Server functions already
    // enforce this, but blocking the whole UI here prevents leaking the
    // admin shell to ordinary logged-in customers.
    const { data: roles } = await supabase
      .from("user_roles")
      .select("role")
      .eq("user_id", data.user.id);
    const list = (roles ?? []).map((r: { role: string }) => r.role);
    if (!list.includes("admin") && !list.includes("staff")) {
      throw redirect({ to: "/admin/login", search: { reason: "forbidden" } as never });
    }

    return { user: data.user, roles: list };
  },
  component: () => <Outlet />,
});
